import { useState } from 'preact/hooks';
import { ChorusMark } from './chorus';
import styles from './InstallBanner.module.css';

interface InstallBannerProps {
  onInstall: () => Promise<boolean>;
}

export function InstallBanner({ onInstall }: InstallBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div class={styles.banner}>
      <div class={styles.markWrap} aria-hidden="true">
        <ChorusMark size={20} />
      </div>
      <div class={styles.body}>
        Add OurTake to your home screen for faster access — <span class={styles.bodyEmphasis}>no app needed</span>.
      </div>
      <button
        onClick={async () => {
          const installed = await onInstall();
          if (installed) setDismissed(true);
        }}
        class={styles.installButton}
      >
        Install
      </button>
      <button
        onClick={() => setDismissed(true)}
        class={styles.close}
        aria-label="Dismiss install banner"
      >
        ×
      </button>
    </div>
  );
}
